import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import RenderTextField from '../../../utils/renderFields/RenderTextField';
import RenderSelectField from '../../../utils/renderFields/RenderSelectField';
import countryCode from '../../../utils/bindings/countryCode';
import deliveryType from '../../../utils/bindings/deliveryType';
import validate from './validate';
import { Title } from './style';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`;

let RecipientInformationsStep = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Title>Informations destinataire</Title>
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Field
          name="productIsInStock"
          id="is-in-stock"
          label="où se trouvent les produits"
          component={RenderSelectField}
          datas={[
            {
              value: 'notInStock',
              name:
                'Un coursier doit venir chercher la commande ou je l’amène chez Sympl',
              id: 1
            },
            {
              value: 'inStock',
              name: 'Les produits sont dans le stock de Sympl',
              id: 2
            }
          ]}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={6}>
        <Field
          name="recipient.lastname"
          id="given-name"
          label="Nom"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={6}>
        <Field
          name="recipient.firstname"
          label="Prénom"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={12}>
        <Field
          name="recipient.companyName"
          label="Nom de l'entreprise"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={12}>
        <Field
          name="recipientAddress.street"
          label="Adresse"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={12}>
        <Field
          name="recipientAddress.complement"
          label="Complement"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={4}>
        <Field
          name="recipientAddress.city"
          label="Ville"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={4}>
        <Field
          name="recipientAddress.postalCode"
          label="Code postal"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={4}>
        <Field
          name="recipientAddress.countryCode"
          label="Pays"
          component={RenderSelectField}
          datas={countryCode}
          fullWidth
        />
      </Grid>
      <Grid item md={12}>
        <Field
          name="deliveryType"
          label="Mode de livraison"
          component={RenderSelectField}
          datas={deliveryType}
          fullWidth
        />
      </Grid>
    </Grid>
    <ButtonContainer>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        style={{ width: 130 }}
      >
        Suivant
      </Button>
    </ButtonContainer>
  </form>
);

const mapStateToProps = () => ({
  initialValues: {
    recipient: {},
    recipientAddress: {},
    items: [{ customsDeclaration: {} }],
    insuranceAmount: 0
  }
});

RecipientInformationsStep = reduxForm({
  form: 'addCommandForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(RecipientInformationsStep);

RecipientInformationsStep.propTypes = {
  handleSubmit: PropTypes.func
};

export default connect(mapStateToProps)(RecipientInformationsStep);
